module.exports = __webpack_public_path__ + "img/s-main.213d6237.svg";